import { templateSchedule } from "~/shared/const/scheduleDefaults";
import { WeeklySchedule } from './WeeklySchedule';
import { IScheduleProps } from "~/shared/types/types";
import { scheduleStyles } from "./schedule.styles";
import React from "react";

export const Schedule: React.FC<IScheduleProps> = ({
  schedule,
  setSchedule,
  handleCloseSchedule,
}) => {
  return (
    <>
      <style>{scheduleStyles}</style>
      <h1 style={{ textAlign: 'center', margin: '20px 0 30px', color: '#333' }}>
        Расписание работы
      </h1>
      <WeeklySchedule
        schedule={schedule}
        scheduleData={templateSchedule}
        setSchedule={setSchedule}
        handleCloseSchedule={handleCloseSchedule}
      />
    </>
  );
};
